module.exports = __webpack_public_path__ + "img/SAFo_KeyTakeAways_Physical.210f5767.svg";